import React from 'react';

import LoginBackgroundImage from '../controls/images/loginPage/LoginBackgroundImage';

interface AuthenticationLayoutProps {
  children: React.ReactNode;
}

const AuthenticationLayout: React.FC<AuthenticationLayoutProps> = ({
  children,
}) => {
  return (
    <div className="relative flex min-h-screen">
      <div className="fixed inset-0 z-[-1]">
        <LoginBackgroundImage />
      </div>
      <main className="absolute inset-0 flex items-center justify-center fluid-desktop:justify-end px-4 fluid-desktop:pr-8 xl:pr-16 2xl:pr-24 overflow-y-auto nest-hub-right">
        <div className="my-auto py-4 sm:py-6">
          <section className="flex flex-col">
            <img
              src="/GolfersHonoursLogo.png"
              alt="Golfers Honours Logo"
              className="mb-4 sm:mb-6 h-28 sm:h-32 md:h-36 lg:h-44 xl:h-52 mx-auto"
            />
            <div className="text-[2rem] sm:text-[2.3rem] font-semibold text-primary-300 mb-2 sm:mb-4 mx-auto">
              Golfers Honours
            </div>

            <div className="flex flex-col leading-4">
              {children}
              <div className="mt-3 text-center">
                <footer className="text-sm font-light text-slate-400">
                  © 2025 Golfers Honours. All Rights Reserved.
                </footer>
              </div>
            </div>
          </section>
        </div>
      </main>
    </div>
  );
};

export default AuthenticationLayout;
